import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import aboutTranslations from './Resource/About'
import contactTranslations from './Resource/Contact'
import CopyTradeTranslations from './Resource/CopyTrade'
import DataTranslations from './Resource/Data'
import errorTranslations from './Resource/Error'
import homepageTranslations from './Resource/Homepage'
import layoutTranslations from './Resource/Layout'
import MiningTranslations from './Resource/Mining'
import PartnersTranslations from './Resource/Partners'
import PrivacyPolicyTranslations from './Resource/PrivacyPolicy'
import ProductsTranslations from './Resource/Products'
import servicesTranslations from './Resource/Services'
import TechnologyTranslations from './Resource/Technology'
import TermsOfUseTranslations from './Resource/TermsOfUse'
import TraderNewsApiTranslations from './Resource/TraderNewsApi'
import TradingStrategyTranslations from './Resource/TradingStrategies'

const fallbackLanguage = 'en-US'
const lookupKey = 'pm-lang'

i18n
  .use(initReactI18next)
  .init({
    detection: {
      order: ['cookie', 'zhDetector', 'navigator'],
      caches: ['cookie'],
      lookupCookie: lookupKey,
      cookieDomain: process.env.REACT_APP_PORTAL_AITRADE_DOMAIN,
    },
    resources: {
      'en-US': {
        translation: {
          ...layoutTranslations['en-US'],
          ...CopyTradeTranslations['en-US'],
          ...TradingStrategyTranslations['en-US'],
          ...TraderNewsApiTranslations['en-US'],
          ...MiningTranslations['en-US'],
          ...DataTranslations['en-US'],
          ...TechnologyTranslations['en-US'],
          ...homepageTranslations['en-US'],
          ...aboutTranslations['en-US'],
          ...servicesTranslations['en-US'],
          ...contactTranslations['en-US'],
          ...errorTranslations['en-US'],
          ...ProductsTranslations['en-US'],
          ...PartnersTranslations['en-US'],
          ...PrivacyPolicyTranslations['en-US'],
          ...TermsOfUseTranslations['en-US'],
        },
      },
    },
    lng: i18n.options.lng,
    debug: false,
    fallbackLng: fallbackLanguage,
    interpolation: {
      escapeValue: false,
    },
  })
  .catch(() => null)

export default i18n
